import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { GlobalMessageService, OccProductSearchAdapter, AuthService } from '@spartacus/core';
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
} from '@spartacus/storefront';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';

import { CategoryPageService } from 'src/app/customServices/category-page.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';
//import { WebtrekkSmartPixelAngular } from '@webtrekk-smart-pixel/angular';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { searchWebtrekkTrackingService } from '../../search-bar/searchWebtrekkTrackingService';
import { ActiveCartFacade } from '@spartacus/cart/base/root';

@Component({
  selector: 'app-kb-product-list',
  templateUrl: './kb-product-list.component.html',
  styleUrls: ['./kb-product-list.component.scss'],
  standalone: false
})
export class KbProductListComponent extends ProductListComponent {
  crossRefModel$: any;
  docModel$: any;
  softwareModel$: any;
  defaultPageSize: any = 10;
  @Input() categoryCode: any;
  @Input() categoryData: any;
  isMobile: boolean;
  selectedTabIndex = 0;
  isCategoryDataPresent: boolean = false;
  Facetmodel$: any;
  categoryCode1: any;
  searchQuery: any;
  productApiFlag: boolean = true;
  private categoryFacetSubject1 = new BehaviorSubject<any>(null);
  oTcategoryData$ = this.categoryFacetSubject1.asObservable();
  crossCount: any;
  docCount: any;
  softCount: any;
  initalCounter: number = 0;

  doesLangChanged: boolean = false;
  private takeUntil$ = new Subject<void>();
  currentcountry: string;
  productModelCopy: any;
  crossRefModelCopy: any;
  docModelCopy: any;
  softModelCopy: any;
  isLoggedIn: boolean = false;
  selectedLang: string;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID;
  currentB2bUnitSendToWebtrack !: string;
  constructor(
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig,
    public breakpointObserver: BreakpointObserver,
    private AuthService: AuthService,
    private CategoryService: CategoryPageService,
    public router: Router,
    private activateRoute: ActivatedRoute,
    private viewportScroller: ViewportScroller,
    //private pixel: WebtrekkSmartPixelAngular,
    private langService: KBLanguageService,
    private cdr: ChangeDetectorRef,
    private cartTrackingService: CartTrackingService,
    private searchTrackingService: searchWebtrekkTrackingService,
    private activeCartService: ActiveCartFacade,
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.takeUntil$)).subscribe((result) => {
      this.isMobile = result.matches;
      if (this.isMobile) {
        this.setViewMode(this.ViewModes.Grid);
      } else {
        this.setViewMode(this.ViewModes.List);
      }
    });
    this.AuthService.isUserLoggedIn()
      .pipe(distinctUntilChanged(), takeUntil(this.takeUntil$))
      .subscribe((isuserLogged) => {
        this.isLoggedIn = isuserLogged;
      });
    this.activeCartService.getActive().pipe(
      take(1)
    ).subscribe((item: any) => {
      this.currentB2bUnitSendToWebtrack = item?.currentB2BUnit?.uid;
      this.WebTrekk_Search();
    });


  }
  override ngOnInit() {
    //this.WebTrekk_Search();
    this.activateRoute.params.pipe(takeUntil(this.takeUntil$)).subscribe((data) => {
      this.searchQuery = data?.['query'];
      this.selectedTabIndex = 0;
      this.langService
        .getActive()
        .pipe(takeUntil(this.takeUntil$), distinctUntilChanged())
        .subscribe((langChange) => {
          this.initialTabscount();
          this.doesLangChanged = true;
          this.currentcountry = langChange;
        });
      if (!this.doesLangChanged) {
        this.initialTabscount();
      }
    });
  }
  WebTrekk_Search() {
    this.activateRoute.params.pipe(takeUntil(this.takeUntil$)).subscribe((data) => {
      this.searchQuery = data?.['query'];
      this.searchTrackingService.trackAction(this.searchQuery);
    });
    /*   this.pixel.page('PLP', {
        search: this.searchQuery,
      }); */
  }

  flattenCrossReferences(response) {
    const flattenedProducts = response.products?.flatMap(product => {
      return product.crossReference.map(xref => ({
        ...product,
        crossReference: [xref],
        crossReferenceTarget: xref.target,
        crossReferenceWebName: xref.webName
      }));
    });
    return {
      ...response,
      products: flattenedProducts,
    };
  }

  initialTabscount() {
    this.crossRefModel$ = this.productListService.getCrossRefDetails(this.defaultPageSize, this.searchQuery, 0, 'sort-asc');
    this.softwareModel$ = this.productListService.getSoftwareDetails(this.defaultPageSize, this.searchQuery, 0);
    this.docModel$ = this.productListService.getDocumentDetails(this.defaultPageSize, this.searchQuery, 0);

    combineLatest([
      this.model$,
      this.crossRefModel$,
      this.softwareModel$,
      this.docModel$
    ]).pipe(takeUntil(this.takeUntil$)).subscribe(([productModel, crossRefModel, softwareModel, docModel]: any) => {
      //this.selectedTabIndex = 0;

      this.productModelCopy = productModel;
      this.cartTrackingService.plpPageViewProduct(this.productModelCopy.products, this.currentB2bUnitSendToWebtrack);
      crossRefModel = this.flattenCrossReferences(crossRefModel);
      this.crossRefModelCopy = crossRefModel;
      this.docModelCopy = docModel;
      this.softModelCopy = softwareModel;

      this.productListService.countDetails$.next({
        productModel,
        crossRefModel,
        softwareModel,
        docModel
      });

      this.timeout = setTimeout(() => {
        if (this.productModelCopy.productsCounts > 0) {
          this.selectedTabIndex = 0;
        }
        if (this.productModelCopy.productsCounts == 0) {
          this.selectedTabIndex = 1;
        }
        if (this.productModelCopy.productsCounts == 0 && this.crossRefModelCopy.crossRefCounts == 0) {
          this.selectedTabIndex = 2;
        }
        if (
          this.productModelCopy.productsCounts == 0 &&
          this.crossRefModelCopy.crossRefCounts == 0 &&
          this.docModelCopy.documentsCounts == 0
        ) {
          this.selectedTabIndex = 3;
        }

        this.cdr.detectChanges();
        this.productListService.selectedTabIndex.next(this.selectedTabIndex);
      }, 500);
    });
  }

  changePageSize(pageSize: any, model: any) {
    this.defaultPageSize = pageSize;
    this.searchProduct(model.pagination.currentPage, Number(pageSize), model.pagination.sort, model);
  }

  searchProduct(currentPage: any, pageSize: any, sort: string, model: any) {
    const pagination = {
      currentPage: currentPage,
      pageSize: pageSize,
      sort: sort,
      text: this.searchQuery
    };

    if (this.selectedTabIndex == 0) {
      const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
      this.searchService.search(query, pagination).pipe(takeUntil(this.takeUntil$)).subscribe((data) => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      });
    } else {
      const e = {
        index: this.selectedTabIndex,
      };
      this.changePageCustom(0, model, e.index);
    }
  }

  changePage(page: number, model: any) {
    this.searchProduct(page, model.pagination.pageSize, model.pagination.sort, model);
  }
  tabClickHandle(e, modelData) {

    this.selectedTabIndex = e.index;
    this.productListService.selectedTabIndex.next(e.index);
    this.defaultPageSize = 12;
    this.productListService.countDetails$.next({
      productModel: this.productModelCopy,
      crossRefModel: this.crossRefModelCopy,
      docModel: this.docModelCopy,
      softwareModel: this.softModelCopy,
    });
  }

  sortListCrossRef(e, model) {
    this.productListService
      .getCrossRefDetails(
        this.defaultPageSize,
        model.freeTextSearch,
        model.pagination.currentPage,
        e
      ).pipe(takeUntil(this.takeUntil$))
      .subscribe((data) => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          crossRefModel: data,
        });
      });
  }

  sortListDocs(e, model) {
    this.productListService
      .getDocumentDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery(model.currentQuery.query.value),
        model.pagination.currentPage,
        e
      ).pipe(takeUntil(this.takeUntil$))
      .subscribe((data) => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          docModel: data,
        });
      });
  }

  sortListProduct(e, model) {
    const pagination = {
      currentPage: model.pagination.currentPage,
      pageSize: model.pagination.pageSize,
      sort: e,
      text: this.searchQuery
    };
    this.searchService
      .search(this.productListService.DecodeQuery(model.currentQuery.query.value), pagination).pipe(takeUntil(this.takeUntil$))
      .subscribe((data) => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      });
  }

  sortListSoftware(e, model) {
    this.productListService
      .getSoftwareDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery(model.currentQuery.query.value),
        model.pagination.currentPage,
        e
      ).pipe(takeUntil(this.takeUntil$))
      .subscribe((data) => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          softwareModel: data,
        });
      });
  }

  changePageCustom(currentPage, model, type) {
    this.viewportScroller.scrollToPosition([0, 200]);
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    if (type == 1) {
      this.productListService
        .getCrossRefDetails(this.defaultPageSize, model.freeTextSearch, currentPage, model.pagination.sort).pipe(takeUntil(this.takeUntil$))
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            crossRefModel: data,
          });
        });
    } else if (type == 2) {
      this.productListService
        .getDocumentDetails(this.defaultPageSize, query, currentPage, model.pagination.sort).pipe(takeUntil(this.takeUntil$))
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            docModel: data,
          });
        });
    } else if (type === 3) {
      this.productListService
        .getSoftwareDetails(model.pagination.pageSize, query, currentPage, model.pagination.sort).pipe(takeUntil(this.takeUntil$))
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            softwareModel: data,
          });
        });
    } else if (type == 0) {
      const pagination = {
        currentPage: currentPage,
        pageSize: model.pagination.pageSize,
        sort: model.pagination.sort,
        text: this.searchQuery
      };
      this.searchService.search(query, pagination).pipe(takeUntil(this.takeUntil$)).subscribe((data) => {
        this.cartTrackingService.plpPageViewProduct(data.products, this.currentB2bUnitSendToWebtrack);
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      });
    }
  }
  selectTab(tab: number) {
    this.selectedTabIndex = tab;
    this.productListService.selectedTabIndex.next(this.selectedTabIndex);
    this.defaultPageSize = 12;
    this.productListService.countDetails$.next({
      productModel: this.productModelCopy,
      crossRefModel: this.crossRefModelCopy,
      docModel: this.docModelCopy,
      softwareModel: this.softModelCopy,
    });


  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.takeUntil$.next();
    this.takeUntil$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}
